module.exports = require("ngx-bootstrap/datepicker");